import { useState } from "react";
import {
    Box,
    Card,
    TextField,
    Typography,
    Button,
    IconButton,
    InputAdornment
} from "@mui/material";
import { motion } from "motion/react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../toastify/config";
import apiSafibc from "../../axios/axios";
import LoadingSpinner from "./Spinner";


const Registrarse = () => {
    const [errorPassword, setErrorPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false)

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.#_\-])[A-Za-z\d@$!%*?&.#_\-]{8,12}$/;

    const [form, setForm] = useState({
        nombre: "",
        email: "",
        password: "",
        confirmPassword: ""
    });

    const [showPass, setShowPass] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!passwordRegex.test(form.password)) {
            Swal.fire({
                icon: 'info',
                title: 'Contraseña',
                text: 'La contraseña debe tener entre 8 y 12 caracteres, incluir mayúscula, minúscula, número y carácter especial.'
            })
            return;
        }

        if (form.password !== form.confirmPassword) {
            alert("Las contraseñas no coinciden");
            return;
        }

        if (!form.nombre) {
            return Swal.fire({
                icon: 'info',
                title: 'Nombre',
                text: 'Es necesario agregar tu nombre!'
            })
        }

        if (!form.email) {
            return Swal.fire({
                icon: 'info',
                title: 'Correo',
                text: 'Es necesario agregar tu correo!'
            })
        }


        setIsLoading(true)
        const enviarFormulario = async () => {
            
            try {
                const registrarse = await apiSafibc.post('/blog/registrar-usuario', form, {
                    headers: {
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setIsLoading(false)

                Swal.fire({
                    icon: 'info',
                    title: 'Se ha registrado correctamente!',
                    text: registrarse.data.mensaje
                }).then((result) => {
                    window.location.href = '/iniciar-sesion'  
                })
            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al registrarse, favor de volver a intentarlo!'
                    }
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }

        }

        enviarFormulario()

    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "linear-gradient(135deg, #0f172a, #1e293b)",
                p: 2
            }}
        >
            {isLoading ?
                <LoadingSpinner />
                : null}
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                style={{ width: "100%", maxWidth: 420 }}
            >
                <Card
                    sx={{
                        p: 4,
                        borderRadius: 4,
                        backdropFilter: "blur(10px)",
                        background: "rgba(255,255,255,0.05)",
                        color: "#fff"
                    }}
                    elevation={0}
                >
                    <Typography variant="h5" mb={1} fontWeight="bold">
                        Crear cuenta
                    </Typography>

                    <Typography variant="body2" mb={3} sx={{ opacity: 0.7 }}>
                        Regístrate para comenzar
                    </Typography>

                    <form onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label="Nombre"
                            name="nombre"
                            margin="normal"
                            value={form.nombre}
                            onChange={handleChange}
                            InputLabelProps={{ style: { color: "#ccc" } }}
                            sx={inputStyles}
                        />

                        <TextField
                            fullWidth
                            label="Correo"
                            name="email"
                            margin="normal"
                            value={form.email}
                            onChange={handleChange}
                            InputLabelProps={{ style: { color: "#ccc" } }}
                            sx={inputStyles}
                        />

                        <TextField
                            fullWidth
                            label="Contraseña"
                            name="password"
                            type={showPass ? "text" : "password"}
                            margin="normal"
                            value={form.password}
                            onChange={(e) => {
                                handleChange(e);
                                setErrorPassword(!passwordRegex.test(e.target.value));
                            }}
                            error={errorPassword}
                            helperText={
                                errorPassword
                                    ? "8-12 caracteres, mayúscula, minúscula, número y símbolo"
                                    : ""
                            }
                            InputLabelProps={{ style: { color: "#ccc" } }}
                            sx={inputStyles}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => setShowPass(!showPass)}
                                            edge="end"
                                            sx={{ color: "#ccc" }}
                                        >
                                            {showPass ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />

                        <TextField
                            fullWidth
                            label="Confirmar contraseña"
                            name="confirmPassword"
                            type={showConfirm ? "text" : "password"}
                            margin="normal"
                            value={form.confirmPassword}
                            onChange={handleChange}
                            InputLabelProps={{ style: { color: "#ccc" } }}
                            sx={inputStyles}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => setShowConfirm(!showConfirm)}
                                            edge="end"
                                            sx={{ color: "#ccc" }}
                                        >
                                            {showConfirm ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />

                        <motion.div
                            whileHover={{ scale: 1.03 }}
                            whileTap={{ scale: 0.97 }}
                        >
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{
                                    mt: 3,
                                    py: 1.2,
                                    borderRadius: 3,
                                    textTransform: "none",
                                    fontWeight: "bold",
                                    background: "linear-gradient(135deg, #3b82f6, #2563eb)"
                                }}
                            >
                                Crear cuenta
                            </Button>
                        </motion.div>

                        <Box mt={3} textAlign="center">
                            <Typography variant="body2" sx={{ opacity: 0.7 }}>
                                ¿Ya tienes cuenta?{" "}
                                <motion.span whileHover={{ scale: 1.05 }}>
                                    <Link
                                        to="/iniciar-sesion"
                                        style={{
                                            color: "#60a5fa",
                                            textDecoration: "none"
                                        }}
                                    >
                                        Inicia sesión
                                    </Link>
                                </motion.span>
                            </Typography>
                        </Box>
                    </form>
                </Card>
            </motion.div>
            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </Box>

    );
};

const inputStyles = {
    input: { color: "#fff" },
    "& .MuiOutlinedInput-root": {
        "& fieldset": { borderColor: "#555" },
        "&:hover fieldset": { borderColor: "#888" },
        "&.Mui-focused fieldset": { borderColor: "#3b82f6" }
    }
};

export default Registrarse;